import { LOCATION_CHANGE } from 'connected-react-router'
import {
	SUBSCRIBE,
	SUBSCRIBE_FULFILLED,
	SUBSCRIBE_REJECTED,
	ActionTypes,
} from '../types'

interface MessageState {
	type: 'error' | 'success' | null
	text: string
}

const initialState = {
	type: null,
	text: '',
}

export default function reducer(state: MessageState = initialState, action: ActionTypes): MessageState {
	switch (action.type) {
		case SUBSCRIBE_FULFILLED:
			return {
				type: 'success',
				text: 'Je bent nu ingeschreven voor de winactie!',
			}

		case SUBSCRIBE_REJECTED:
			return {
				type: 'error',
				text: 'Oops! Er ging iets niet goed met de inschrijving',
			}

		case SUBSCRIBE:
		case LOCATION_CHANGE:
			return initialState

		default:
			return state
	}
}
